
import { NgModule } from '@angular/core';
import { DataTableModule, PanelModule, SharedModule, CalendarModule, InputMaskModule, PaginatorModule, DialogModule, SelectButtonModule, MultiSelectModule, ConfirmDialogModule, ConfirmationService, AutoCompleteModule, } from 'primeng/primeng';
import { DatepickerModule, TooltipModule, PopoverModule } from 'ngx-bootstrap';
import {TableModule} from 'primeng/table';
import { CoreModule } from '.././core/core.module';
import { ReceivedSMSComponent  } from './received-sms.component';
import { ReceivedSmsService  } from './received-sms.service';
import { TranslateModule, TranslateLoader, TranslateService } from "@ngx-translate/core";
//import { routing } from './receivedsms.routing';
import { DatePipe } from '@angular/common';
//import { SmsReceivedComponent } from './receivedsms.component';
import { SMSNotification  } from './sms-notification.component';
import { ShareModule } from '../shared/share.module';
import { DispatchBoardService } from '../dispatch/dispatchboard/dispatch-board.service';

@NgModule({
    imports: [  
        TranslateModule,
        TableModule,
        DataTableModule,
        PanelModule,
        SharedModule,
        CoreModule,
        InputMaskModule,
        SelectButtonModule,        
        MultiSelectModule,
        ConfirmDialogModule,
        DialogModule,
        AutoCompleteModule,
        PaginatorModule,
        TooltipModule.forRoot(),
        CalendarModule,
        ShareModule
       // routing,      
    ],
    declarations: [ReceivedSMSComponent,SMSNotification], //SmsReceivedComponent
    exports:[ReceivedSMSComponent,SMSNotification], //SmsReceivedComponent
    providers: [ReceivedSmsService,DatePipe,DispatchBoardService]
   
})
export class ReceivedSMSModule {}

